import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.colors.darkBackground};
  color: white;

  .OutsideWrapper {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .NavigationContainer {
    display: none;
    flex-direction: column;
    align-items: flex-end;
    @media (min-width: 768px) {
      display: flex !important;
    }
  }
`;

export const Logo = styled.a`
  font-size: 1.5rem;
  color: white;
  margin: 0;
  cursor: pointer;
  img {
    height: 50px;
  }
  @media (min-width: 1023px) {
    img {
      height: 70px;
    }
  }
`;

export const Nav = styled.nav`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 767px) {
    display: none; /* Hide nav links on mobile */
  }
`;

export const NavLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-size: 1rem;
  font-weight: 700;
  transition: color 0.3s;
  line-height: 40px;

  &:hover {
    color: ${({ theme }) => theme.colors.body};
  }
`;

export const HamburgerIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const MobileMenu = styled.div`
  position: fixed;
  top: 72px;
  right: 0;
  width: 100%;
  background-color: #333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  z-index: 1000;
  padding: 2rem;
  border-top: 6px solid ${({ theme }) => theme.colors.primary};
  border-bottom: 6px solid ${({ theme }) => theme.colors.primary};

  @media (min-width: 769px) {
    display: none;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
`;

export const ContactNumber = styled.a`
  color: white;
  margin-right: -20%;
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const ContactNumberDesktop = styled.a`
  color: white;
  display: none;
  font-size: 19px;
  @media (min-width: 768px) {
    display: block;

    &:hover {
      color: ${({ theme }) => theme.colors.primary}!important;
    }
  }
`;

export const DesktopNav = styled.div`
  height: 60px;
  background-color: ${({ theme }) => theme.colors.primary};
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 1rem 2rem;
  display: none;
  position: relative;
  @media (min-width: 768px) {
    display: flex;
  }
`;

export const DesktopLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.darkBackground};
  text-transform: uppercase;
  border-bottom: none;
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 15px;
  cursor: ${({ $isInteractive }) => ($isInteractive ? "pointer" : "default")};

  &:hover {
    color: ${({ theme, $isInteractive }) => ($isInteractive ? theme.colors.body : theme.colors.darkBackground)};
  }
`;

export const DesktopLinkWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const DesktopDropdownOverlay = styled.div`
  position: fixed;
  top: ${({ $top }) => `${$top}px`};
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.48);
  z-index: 25;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const DropdownMenu = styled.div`
  display: none;
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: white;
  color: ${({ theme }) => theme.colors.darkBackground};
  min-width: 180px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  z-index: 20;
  padding: 0.5rem 0;

  ${DesktopLinkWrapper}:hover & {
    display: block;
  }

  @media (max-width: 767px) {
    position: static;
    box-shadow: none;
    background: transparent;
    padding: 0;
  }
`;

export const DropdownItem = styled.a`
  display: block;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors.darkBackground};
  font-weight: 700;
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => theme.colors.lightBackground};
  }
`;

export const DropdownPanel = styled.div`
  position: absolute;
  left: 0;
  top: calc(100% + 0px);
  width: 100%;
  left: 0;
  background: linear-gradient(135deg, #f7faef 0%, #edf4d3 100%);
  color: ${({ theme }) => theme.colors.darkBackground};
  border-top: 2px solid rgba(0, 0, 0, 0.12);
  z-index: 30;
  padding: 2rem;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.14);

  display: flex;
  gap: 1.5rem;
  align-items: stretch;
  justify-content: center;

  a {
    color: ${({ theme }) => theme.colors.darkBackground};
    text-decoration: none;
  }

  @media (max-width: 767px) {
    position: static;
    width: 100%;
    box-shadow: none;
    padding: 0.5rem 1rem;
    background: transparent;
    display: block;
  }
`;

export const DropdownCopy = styled.div`
  width: min(100%, 520px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.9rem;
`;

export const DropdownEyebrow = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.darkBackground};
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.75;
`;

export const DropdownHeading = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.darkBackground};
  font-size: 2rem;
  line-height: 1;
`;

export const DropdownLead = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text};
  font-size: 1rem;
  line-height: 1.6;
`;

export const DropdownTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const DropdownText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.98rem;
  line-height: 1.6;
`;

export const DropdownMeta = styled.a`
  align-self: flex-start;
  margin-top: 0.35rem;
  padding: 0.75rem 1rem;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.darkBackground};
  color: ${({ theme }) => theme.colors.body} !important;
  font-weight: 700;

  &:hover {
    background: #1d1d1d;
  }
`;

export const DropdownGallery = styled.div`
  flex: 0 0 340px;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.55rem;
  align-content: center;

  @media (max-width: 900px) {
    flex-basis: 300px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 767px) {
    flex-basis: auto;
    margin-top: 1rem;
    grid-template-columns: 1fr;
  }
`;

export const DropdownGalleryItem = styled.div`
  min-height: 160px;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.65);
  box-shadow: 0 12px 24px rgba(10, 10, 10, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 767px) {
    min-height: 190px;
  }
`;

export const MobileSubmenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  padding-left: 1rem;
`;

export const SubmenuToggle = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  text-align: left;
`;
